/**
 * A class describing a subscription period
 */
export class SubscriptionPeriod {
    constructor(unitCount, unit, iso) {
        this.unitCount = unitCount;
        this.unit = unit;
        this.iso = iso;
    }
}
//# sourceMappingURL=SubscriptionPeriod.js.map